<!-- Zone 1 redesign (29/10/2026): icon, title and version on one compact
     header, the legal text in a readable card, and the consent with its button
     in a footer that stays put with a shadow, so the member always sees what
     is asked of them while they scroll. -->
<ion-content class="ion-padding">
  <div class="legal-head">
    <div class="legal-head__icon">
      <span class="material-symbols-outlined">receipt_long</span>
    </div>
    <div class="legal-head__text">
      <h1 class="legal-head__title">{{ 'USER_PROFILE.PRIVACY.GCS' | translate }}</h1>
      @if (version) {
      <span class="legal-head__version">{{ 'LEGAL_TEXT_UPDATE.VERSION' | translate : { version: version } }}</span>
      }
    </div>
  </div>

  <div class="policy-html" [innerHTML]="policyHtml"></div>
</ion-content>

<div class="legal-footer">
  <ion-item lines="none" class="checkbox-item">
    <ion-checkbox slot="start" [(ngModel)]="accepted" (ngModelChange)="changAccepted($event)"></ion-checkbox>
    <ion-label>{{ 'TERMS_POLICY_PAGE.I_AGREE_TO_GCS_POLICY' | translate }}</ion-label>
  </ion-item>

  @if (submitFailed) {
  <div class="ion-padding-horizontal text-sm" style="color: var(--ion-color-danger)">
    {{ 'TERMS_POLICY_PAGE.ACCEPT_FAILED' | translate }}
  </div>
  }

  <div class="legal-footer__button" (click)="onSubmit()">
    <ion-button [disabled]="!accepted || loading" class="w-full text-base">
      {{ 'BUTTONS.ACCEPT_CONTINUE' | translate }}
    </ion-button>
  </div>
</div>
